import { useRecoilValue } from 'recoil'
import { useCallback, useState } from 'react'
import useTableWithRequest from '@/shared/Tables/Table/ctrl/useTableWithRequest.ts'
import Table from '@/shared/Tables/Table'
import systemEventsTableFields from './systemEvents.table.fields.tsx'
import systemEventsApi from '../../systemEvents.api.ts'
import { ISystemEventFiltersState } from '../../systemEventFilters.atom.ts'
import systemEventsUtils from '../../systemEvents.utils.ts'
import userAtom from '@/pages/User/user.atom.ts'
import { ISystemEvent } from '../../systemEvents.types.ts'

interface IProps {
  filterState: ISystemEventFiltersState
}

const SystemEventsTable = ({ filterState }: IProps) => {
  const userInfo = useRecoilValue(userAtom)
  const isAdmin = userInfo.isAdmin

  const [items, setItems] = useState<ISystemEvent[]>([])

  const dataLoad = useCallback(
    async (params: any) => {
      const filterParam = systemEventsUtils.getParamsListByFilterState(filterState)

      return systemEventsApi.list({
        ...params,
        ...filterParam,
      })
    },
    [filterState.type, filterState.created_gte, filterState.created_lte, filterState.search]
  )

  const tableCtrl = useTableWithRequest({
    serverSideOrder: false,
    fields: isAdmin ? systemEventsTableFields.admin : systemEventsTableFields.client,
    tableKey: `systemEvents`,
    itemKey: 'id',
    dataFetcher: dataLoad,
    items,
    setItems,
    storageType: 'regularState',
  })

  return <Table {...tableCtrl} items={items as any} itemKey="id" />
}

export default SystemEventsTable
